// extracted by mini-css-extract-plugin
export default {"loadingScreen":"auth-provider_loadingScreen__CuMH5"};